export {
  isSomeElementSelected,
  getElementsWithinSelection,
  getCommonAttributeOfSelectedElements,
  getSelectedElements,
  getTargetElements,
} from "@excalidraw/element/selection";
export { calculateScrollCenter } from "./scroll";
export {
  hasBackground,
  hasStrokeWidth,
  hasStrokeStyle,
  canHaveArrowheads,
  canChangeRoundness,
} from "@excalidraw/element/comparisons";
export {
  getNormalizedZoom,
  getNormalizedGridSize,
  getNormalizedGridStep,
} from "./normalize";
